function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF6465"
    },
    points: "427.82,157.598 352.923,120.519 352.923,31.677 427.82,31.677  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF6465"
    },
    points: "65.813,181.685 65.813,510.242 446.187,510.242 446.187,181.685 256,87.381  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DD2F0"
    },
    d: "M256,175.706L256,175.706c-26.813,0-48.55,21.737-48.55,48.55v48.55h97.101v-48.55 C304.55,197.443,282.813,175.706,256,175.706z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.446,
    y: 326.829,
    style: {
      fill: "#FFD782"
    },
    width: 97.098,
    height: 183.406
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    points: "65.813,181.685 65.813,258.997 256,159.535 446.187,258.997  446.187,181.685 256,87.381 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD782"
    },
    points: "483.36,236.594 256,117.691 28.64,236.594 0,181.832 256,47.953 512,181.832 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.92,
    y: 31.677,
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    width: 74.9,
    height: 58.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.554,
    y: 1.758,
    style: {
      fill: "#FFD782"
    },
    width: 111.633,
    height: 51.514
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.584d4e4f8a950115b9cd6f2ebc462534.svg";
export { ForwardRef as ReactComponent };